// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GoalDataPoints__container___gve5t {
    font-size: 11px;
    margin-top: 10px;
    display: block;
}

.GoalDataPoints__noGoalDatapoints___IDkoP {
    color: silver;
    font-style: italic;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GoalDataPoints__container___gve5t`,
	"noGoalDatapoints": `GoalDataPoints__noGoalDatapoints___IDkoP`
};
module.exports = ___CSS_LOADER_EXPORT___;
